import { createSlice } from "@reduxjs/toolkit";
import { GET_INCOMPLETE_JOB, GET_INCOMPLETE_JOB_BY_ID } from "./IncompleteServiceSlice.action";

const IncompleteServiceSlice = createSlice({
    name: "incompleteJob",
    initialState: {
        incompleteJobList: [],
        loading: false,
        error: null,
        incompleteJobListDetails: {}
    },
    extraReducers: (builder) => {
        builder
            .addCase(GET_INCOMPLETE_JOB.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_INCOMPLETE_JOB.fulfilled, (state, action) => {
                state.loading = false;
                state.incompleteJobList = action.payload;
            })
            .addCase(GET_INCOMPLETE_JOB.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })

            .addCase(GET_INCOMPLETE_JOB_BY_ID.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GET_INCOMPLETE_JOB_BY_ID.fulfilled, (state, action) => {
                state.loading = false;
                state.incompleteJobListDetails = action.payload;
            })
            .addCase(GET_INCOMPLETE_JOB_BY_ID.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
    }
})
export default IncompleteServiceSlice;